module.exports = __webpack_public_path__ + "img/1F913.e019e20f.svg";